import { useState } from 'react';
import styled from 'styled-components';

import imagemDer from '../../assets/imagensDERs/sisafDerModuloProaq.png';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 1.15rem;
  text-align: justify;
  padding: 5px;

  ul {
    margin-bottom: 15px;
  }
`;

const Definicao = styled.div`
  margin-bottom: 20px;
`;

const AbasContainer = styled.div`
  display: flex;
  border-bottom: 2px solid #b0c4de;
  margin-bottom: 15px;
`;

const Aba = styled.div<{ active: boolean }>`
  padding: 10px 20px;
  cursor: pointer;
  font-weight: ${({ active }) => (active ? 'bold' : 'normal')};
  background-color: ${({ active }) => (active ? '#869ddb83' : 'transparent')};
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;

  &:hover {
    background-color: #b0c4de;
  }
`;

const ImagemDer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px;
  border-radius: 10px;
  border: 1px solid lightgray;
  background-color: lightgray;
  margin-bottom: 25px;

  img {
    height: 30vh;
    border-radius: 10px;
    width: auto;

    transition: transform 0.3s ease-in-out;

    &:hover {
      /* transform: scale(1.5); */
    }
  }
`;

const AbaDefinicoes = () => {
  return (
    <>
      <ul>
        <li>
          <b>Processo Aquisitivo</b>
        </li>
        <ul>
          <li>
            Um Processo Aquisitivo pode ser definido como um conjunto
            estruturado de etapas que centraliza, organiza e viabiliza a
            aquisição de produtos farmacêuticos no âmbito do DAF.
          </li>
        </ul>

        <li style={{ padding: '10px' }}>
          Modalidade de Aquisição:{' '}
          <b
            style={{
              background: 'yellow',
              padding: '7px',
              borderRadius: '10px',
            }}
          >
            Emergencial
          </b>
        </li>
        <ul>
          <li>
            É uma modalidade utilizada em situações excepcionais, em que a
            urgência da demanda justifica a dispensa de algumas etapas formais
            do processo licitatório.
          </li>
          <li>
            Características
            <ul style={{ marginBottom: '0px' }}>
              <li>
                Visa atender necessidades imediatas e imprevistas, como crises
                sanitárias, desabastecimento crítico ou emergências de saúde
                pública.
              </li>
              <li>
                O processo é mais ágil, mas deve ser devidamente justificado e
                atender aos critérios legais previstos.
              </li>
            </ul>
          </li>
          <li>
            Base legal
            <ul>
              <li>
                Regulamentada por leis que tratam de licitações e contratos,
                como a Lei nº 8.666/1993 e, atualmente, a Lei nº 14.133/2021
                (nova Lei de Licitações e Contratos).
              </li>
            </ul>
          </li>
        </ul>

        <li>
          Modalidade de Aquisição:{' '}
          <b
            style={{
              background: 'yellow',
              padding: '7px',
              borderRadius: '10px',
            }}
          >
            Inexigibilidade
          </b>
        </li>
        <ul>
          <li>
            É utilizada quando há inviabilidade de competição para a
            contratação, tornando impossível realizar um processo licitatório
            competitivo.
          </li>
          <li>
            Características
            <ul style={{ marginBottom: '0px' }}>
              <li>
                Aplica-se quando há exclusividade do fornecedor ou fabricante
                (ex.: medicamentos de alto custo ou específicos de um único
                laboratório).
              </li>
              <li>
                Depende de comprovação formal de que apenas um fornecedor pode
                atender à demanda.
              </li>
            </ul>
          </li>
          <li>
            Base legal
            <ul>
              <li>
                Prevista no Art. 25 da Lei nº 8.666/1993 e mantida na nova Lei
                de Licitações (Art. 74 da Lei nº 14.133/2021).
              </li>
            </ul>
          </li>
        </ul>

        <li style={{ padding: '10px' }}>
          Modalidade de Aquisição:{' '}
          <b
            style={{
              background: 'yellow',
              padding: '7px',
              borderRadius: '10px',
            }}
          >
            Pregão com ARP (Ata de Registro de Preços)
          </b>
        </li>
        <ul>
          <li>
            Modalidade licitatória em que é realizada uma licitação para formar
            um registro de preços de bens ou serviços, permitindo aquisições
            futuras conforme a demanda.
          </li>
          <li>
            Características
            <ul style={{ marginBottom: '0px' }}>
              <li>
                Oferece maior flexibilidade, pois o órgão contratante não
                precisa adquirir todos os itens de imediato.
              </li>
              <li>
                Os fornecedores vencedores são registrados em uma ata válida por
                até 12 meses, permitindo aquisições parceladas.
              </li>
              <li>
                Ideal para produtos com consumo contínuo e previsível, como
                medicamentos básicos e insumos.
              </li>
            </ul>
          </li>
          <li>
            Base legal
            <ul>
              <li>
                Regulada pelo Decreto nº 7.892/2013 e mantida como prática na
                nova Lei de Licitações.
              </li>
            </ul>
          </li>
        </ul>

        <li>
          Modalidade de Aquisição:{' '}
          <b
            style={{
              background: 'yellow',
              padding: '7px',
              borderRadius: '10px',
            }}
          >
            Pregão sem ARP
          </b>
        </li>
        <ul>
          <li>
            Modalidade licitatória direta, sem formação de uma Ata de Registro
            de Preços, utilizada para a aquisição específica de bens ou
            serviços.
          </li>
          <li>
            Características
            <ul style={{ marginBottom: '0px' }}>
              <li>
                O fornecimento ocorre integralmente após a conclusão do processo
                licitatório.
              </li>
              <li>
                Mais indicado para aquisições pontuais, com demandas já
                definidas e planejadas.
              </li>
              <li>
                Processo mais objetivo, focado em atender uma necessidade
                específica e imediata.
              </li>
            </ul>
          </li>
          <li>
            Base legal
            <ul>
              <li>
                Previsto na Lei nº 10.520/2002 e na nova Lei de Licitações (Art.
                28 da Lei nº 14.133/2021).
              </li>
            </ul>
          </li>
        </ul>
      </ul>
    </>
  );
};

const Entidades = () => {
  return (
    <>
      <ImagemDer>
        <img src={imagemDer}></img>
      </ImagemDer>

      <b>Entidades</b>
      <ul>
        <li>
          <b>PROAQ</b>
        </li>
        <ul>
          <li>
            Entidade que centraliza as informações de identificação do processo
            aquisitivo.
          </li>
        </ul>

        <li>
          <b>PROAQ_ITEM</b>
        </li>
        <ul>
          <li>
            Entidade que especifica os produtos farmacêuticos a serem
            adquiridos, suas quantidades e justificativas.
          </li>
        </ul>

        <li>
          <b>PROAQ_DESTAQUE</b>
        </li>
        <ul>
          <li>
            Entidade para registrar destaques (fatos importantes) relacionados
            ao processo aquisitivo.
          </li>
        </ul>

        <li>
          <b>PROAQ_TRAMITACAO_SEI</b>
        </li>
        <ul>
          <li>
            Entidade que registra as tramitações do processo aquisitivo no SEI,
            indica todas as áreas/setores que o processo tramitou.
          </li>
        </ul>

        <li>
          <b>PROAQ_RESPONSAVEL</b>
        </li>
        <ul>
          <li>Entidade que registra o responsável pelo processo aquisitivo.</li>
        </ul>

        <li>
          <b>PROAQ_FASE</b>
        </li>
        <ul>
          <li>
            Entidade que registra a fase de evolução do processo aquisitivo.
          </li>
        </ul>
      </ul>

      <b>Cardinalidades</b>
      <ul>
        <li>
          <b>PROAQ para PROAQ_ITEM</b>
        </li>
        <ul>
          <li>
            Um processo aquisitivo pode ter 1 ou mais produtos a serem
            adquiridos.
          </li>
        </ul>

        <li>
          <b>PROAQ para PROAQ_DESTAQUE</b>
        </li>
        <ul>
          <li>
            Um processo aquisitivo pode não ter nenhum destaque ou pode ter 1 ou
            mais destaques.
          </li>
        </ul>

        <li>
          <b>PROAQ para PROAQ_TRAMITACAO_SE</b>
        </li>
        <ul>
          <li>Um processo aquisitivo pode ter 1 ou mais tramitações no SEI.</li>
        </ul>

        <li>
          <b>PROAQ para PROAQ_RESPONSAVEL</b>
        </li>
        <ul>
          <li>
            Um processo aquisitivo pode ter 1 ou mais responsáveis. Contudo,
            apenas pode ter uma relação ativa por vez; ou seja, um processo
            aquisitivo não pode estar vinculado a mais de um responsável técnico
            ao mesmo tempo.
          </li>
        </ul>

        <li>
          <b>PROAQ para PROAQ_FASE</b>
        </li>
        <ul>
          <li>Um processo aquisitivo pode ter 1 ou mais fases relacionadas.</li>
        </ul>
      </ul>
    </>
  );
};

const RegrasDeNegocio = () => {
  return (
    <>
      <ul>
        <li>
          <b>Processos Aquisitivos</b>
        </li>
        <ul>
          <li>
            Um processo aquisitivo não pode ser deletado caso esteja vinculado a
            um contrato.
          </li>
          <li>O número do processo aquisitivo é único.</li>
          <li>
            Não pode existir repetição de produto farmacêutico e tipo de cota,
            na entidade PROAQ_ITEM.
          </li>
          <li>
            Usuário apenas pode inserir uma nova fase do processo aquisitivo
            quando a fase anterior for encerrada.
          </li>
        </ul>
      </ul>
    </>
  );
};

const AjudaModuloProaq = () => {
  const [abaAtiva, setAbaAtiva] = useState<
    'definicoes' | 'regras' | 'entidades'
  >('definicoes');

  return (
    <Container>
      <Definicao>
        Módulo que{' '}
        <b>
          centraliza as informações dos processos aquisitivos de produtos
          farmacêuticos do DAF.{' '}
        </b>
        Módulo muito importante para registrar os dados dos processos
        aquisitivos e facilitar o seu monitoramento e acompanhamento.
      </Definicao>

      {/* Abas */}
      <AbasContainer>
        <Aba
          active={abaAtiva === 'definicoes'}
          onClick={() => setAbaAtiva('definicoes')}
        >
          Definições
        </Aba>
        <Aba
          active={abaAtiva === 'entidades'}
          onClick={() => setAbaAtiva('entidades')}
        >
          Entidades
        </Aba>
        <Aba
          active={abaAtiva === 'regras'}
          onClick={() => setAbaAtiva('regras')}
        >
          Regras de Negócio
        </Aba>
      </AbasContainer>

      {/* Conteúdo da Aba Ativa */}
      {abaAtiva === 'definicoes' ? (
        <AbaDefinicoes />
      ) : abaAtiva === 'regras' ? (
        <RegrasDeNegocio />
      ) : (
        <Entidades />
      )}
    </Container>
  );
};

export default AjudaModuloProaq;
